"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var moment = require("moment");
var numeral = require("numeral");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var localStorageUtils_1 = require("../../app/utils/localStorageUtils");
var imageZoomUtils_1 = require("../../app/utils/imageZoomUtils");
var commentsView_1 = require("./commentsView");
var scriptjs = require("scriptjs");
var Masonry = require("masonry-layout");
var imagesLoaded = require("imagesloaded");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.numeral = numeral;
        this.workId = this.options.workId;
        this.statsIsLoading = ko.observable(true);
        this.workStatLoaded = ko.observable(false);
        this.totalCount = ko.observable(0);
        this.readingCount = ko.observable(0);
        this.savedCount = ko.observable(0);
        this.finishedCount = ko.observable(0);
        this.dislikedCount = ko.observable(0);
        this.startDate = ko.observable(moment().startOf("day").add(-6, "days"));
        this.endDate = ko.observable(moment().endOf("day"));
        this.booktrailerVideoUrl = ko.observable();
        this.showFullStats = ko.observable();
        this.statsFilterData = ko.computed(function () {
            return {
                startDate: _this.startDate().toISOString(),
                endDate: _this.endDate().toISOString(),
                itemId: _this.workId,
                groupBy: "work"
            };
        });
        this.booktrailerVideoUrl(options.booktrailerVideoUrl);
        this.showFullStats(options.showFullStats);
        this.isModeratorOrAdmin = this.options.isModeratorOrAdmin;
        localStorageUtils_1.default.addToList(localStorageUtils_1.default.RecentlyViewedKey, options.workId);
        this.loadRecommendations();
        $("#accordion-item-stats").on("accordion:opened", function () {
            ajaxUtils_1.AjaxUtils.get("work/work-stats", { workId: _this.workId })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.totalCount(result.data.totalCount);
                _this.readingCount(result.data.readingCount);
                _this.savedCount(result.data.savedCount);
                _this.finishedCount(result.data.finishedCount);
                _this.dislikedCount(result.data.dislikedCount);
            })
                .always(function () {
                _this.workStatLoaded(true);
            });
            if (_this.showFullStats()) {
                scriptjs([ajaxUtils_1.AjaxUtils.getFullUrl("dist/js/amcharts?v=140717")], function () {
                    ko.computed(function () {
                        _this.statsIsLoading(true);
                        _this.statsFilterData();
                        _this.loadDynamicChart(_this.isModeratorOrAdmin);
                    });
                    $("#accordion-item-stats").off("accordion:opened");
                });
            }
            else {
                $("#accordion-item-stats").off("accordion:opened");
            }
        });
        $("#accordion-item-materials").on("accordion:opened", function () {
            setTimeout(function () {
                if (!$("#masonry")[0])
                    return;
                var masonry = new Masonry("#masonry", {
                    itemSelector: "figure",
                    gutter: ".gutter-sizer",
                    columnWidth: ".grid-sizer",
                    percentPosition: true
                });
                $("#masonry figure")["imagesLoaded"]()
                    .progress(function () {
                    masonry.layout();
                });
                $(window)
                    .on("resize", function () {
                    setTimeout(function () { return masonry.layout(); }, 200);
                });
                imageZoomUtils_1.default.initWorkMaterials();
            }, 200);
            $("#accordion-item-materials").off("accordion:opened");
        });
        $("#accordion-item-series").on("accordion:opened", function () {
            var $seriesSlider = $("#seriesSlider");
            ajaxUtils_1.AjaxUtils.get("work/getByIds", {
                workIds: _this.options.seriesWorkIds,
                checkPrivacy: false
            })
                .done(function (result) {
                if (!result.isSuccessful) {
                    $seriesSlider.hide();
                    return;
                }
                var $sliderWrapper = $seriesSlider.find(".swiper-wrapper");
                $sliderWrapper.removeClass("work-slider-loading");
                $seriesSlider.addClass("work-slider");
                $sliderWrapper.html(result.data.html);
                app.f7.swiper($seriesSlider[0], {
                    slidesPerView: "auto",
                    speed: 300,
                    spaceBetween: 8,
                    slidesPerGroup: 3,
                    grabCursor: true,
                    scrollbar: ".swiper-scrollbar"
                });
            }).fail(function () {
                $seriesSlider.hide();
            });
            $("#accordion-item-series").off("accordion:opened");
        });
        this.loadComments(null, null, false);
    }
    ViewModel.prototype.loadRecommendations = function () {
        var $recommendationsSlider = $("#recommendationsSlider");
        ajaxUtils_1.AjaxUtils.get("widget/workRecommendations", {
            workId: this.workId,
            format: "ebook"
        })
            .done(function (result) {
            if (!result.isSuccessful) {
                $recommendationsSlider.hide();
                return;
            }
            var $sliderWrapper = $recommendationsSlider.find(".swiper-wrapper");
            $sliderWrapper.removeClass("work-slider-loading");
            $recommendationsSlider.addClass("work-slider");
            $sliderWrapper.html(result.data.html);
            app.f7.swiper($recommendationsSlider[0], {
                slidesPerView: "auto",
                speed: 300,
                spaceBetween: 8,
                slidesPerGroup: 3,
                grabCursor: true,
                scrollbar: ".swiper-scrollbar"
            });
        })
            .fail(function () {
            $recommendationsSlider.hide();
        });
    };
    ViewModel.prototype.loadDynamicChart = function (withFraud) {
        var _this = this;
        if (withFraud === void 0) { withFraud = false; }
        var daysInPerios = Math.floor((this.endDate() - this.startDate()) / (1000 * 60 * 60 * 24));
        var minPeriod = "DD";
        var categoryBalloonDateFormat = "MMMM DD, YYYY";
        if (daysInPerios > 40) {
            minPeriod = "MM";
            categoryBalloonDateFormat = "MMMM, YYYY";
        }
        ajaxUtils_1.AjaxUtils.get("report/user-activity-data", this.statsFilterData())
            .done(function (result) {
            // @ts-ignore
            _this.dynamicChart = AmCharts.makeChart("statsChartdiv", {
                language: "ru",
                type: "serial",
                theme: "light",
                valueAxes: [
                    {
                        id: "countAxis",
                        axisAlpha: 0,
                        position: "left",
                        integersOnly: true,
                        title: "Количество просмотров"
                    }, {
                        title: "Время чтения, часы",
                        id: "durationAxis",
                        axisAlpha: 0,
                        gridAlpha: 0,
                        position: "right"
                    }
                ],
                graphs: [
                    {
                        balloonText: "Просмотров: [[value]]",
                        fillAlphas: 0.7,
                        legendValueText: "[[value]]",
                        type: "column",
                        valueField: "totalViewCount",
                        valueAxis: "countAxis"
                    }, {
                        balloonText: "Время чтения: [[value]]",
                        type: "smoothedLine",
                        bullet: "round",
                        bulletBorderAlpha: 1,
                        useLineColorForBulletBorder: true,
                        bulletColor: "#FFFFFF",
                        hideBulletsCount: 30,
                        legendValueText: "[[value]] ч.",
                        fillAlphas: 0,
                        valueField: "spentTime",
                        valueAxis: "durationAxis"
                    }
                ],
                chartCursor: {
                    categoryBalloonDateFormat: categoryBalloonDateFormat,
                    cursorAlpha: 0.1,
                    cursorColor: "#000000",
                    fullWidth: true,
                    valueBalloonsEnabled: false,
                    zoomable: false
                },
                dataDateFormat: "DD.MM.YYYY",
                categoryField: "date",
                categoryAxis: {
                    parseDates: true,
                    dashLength: 1,
                    minorGridEnabled: true,
                    minPeriod: minPeriod
                },
                legend: {
                    equalWidths: false,
                    useGraphSettings: true,
                    align: "center"
                },
                dataProvider: result.data,
                pathToImages: app.rootUrl + "dist/vendor/amcharts/images/"
            });
            _this.statsIsLoading(false);
        });
        if (withFraud) {
            ajaxUtils_1.AjaxUtils.get("report/user-activity-fraud-data", this.statsFilterData())
                .done(function (result) {
                var daysInPerios = Math.floor((_this.endDate() - _this.startDate()) / (1000 * 60 * 60 * 24));
                var minPeriod = "DD";
                var categoryBalloonDateFormat = "MMMM DD, YYYY";
                if (daysInPerios > 40) {
                    minPeriod = "MM";
                    categoryBalloonDateFormat = "MMMM, YYYY";
                }
                _this.fraudDynamicChart = AmCharts.makeChart("fraudStatsChartdiv", {
                    language: "ru",
                    type: "serial",
                    theme: "light",
                    valueAxes: [
                        {
                            id: "countAxis",
                            axisAlpha: 0,
                            position: "left",
                            integersOnly: true,
                            title: "Количество просмотров"
                        }, {
                            title: "Время чтения, часы",
                            id: "durationAxis",
                            axisAlpha: 0,
                            gridAlpha: 0,
                            position: "right"
                        }
                    ],
                    titles: [
                        {
                            "text": "Подозрительные данные"
                        }
                    ],
                    graphs: [
                        {
                            balloonText: "Просмотров: [[value]]",
                            fillAlphas: 0.7,
                            legendValueText: "[[value]]",
                            type: "column",
                            valueField: "totalViewCount",
                            valueAxis: "countAxis",
                            lineColor: "#d770ad"
                        }, {
                            balloonText: "Время чтения: [[value]]",
                            type: "smoothedLine",
                            bullet: "round",
                            bulletBorderAlpha: 1,
                            useLineColorForBulletBorder: true,
                            lineColor: "#ed9121",
                            hideBulletsCount: 30,
                            legendValueText: "[[value]] ч.",
                            fillAlphas: 0,
                            valueField: "spentTime",
                            valueAxis: "durationAxis"
                        }
                    ],
                    chartCursor: {
                        categoryBalloonDateFormat: categoryBalloonDateFormat,
                        cursorAlpha: 0.1,
                        cursorColor: "#000000",
                        fullWidth: true,
                        valueBalloonsEnabled: false,
                        zoomable: false
                    },
                    dataDateFormat: "DD.MM.YYYY",
                    categoryField: "date",
                    categoryAxis: {
                        parseDates: true,
                        dashLength: 1,
                        minorGridEnabled: true,
                        minPeriod: minPeriod
                    },
                    legend: {
                        equalWidths: false,
                        useGraphSettings: true,
                        align: "center"
                    },
                    dataProvider: result.data,
                    pathToImages: window["app"].rootUrl + "dist/vendor/amcharts/images/"
                });
                _this.statsIsLoading(false);
            });
        }
        ;
    };
    ViewModel.prototype.updateBookSize = function () {
        var _this = this;
        ajaxUtils_1.AjaxUtils.post("work/updateBookSize", {
            workId: this.workId
        }).done(function (result) {
            if (result.isSuccessful) {
                _this.reloadPage();
            }
            else {
                alert(result.messages[0]);
            }
        });
    };
    ViewModel.prototype.showAuthModal = function () {
        app.ensureAuth("Только зарегистрированные пользователи могут купить цикл, книгу или подарить награду.", true);
    };
    return ViewModel;
}(commentsView_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=workView.js.map